import Chart from 'react-apexcharts'

const defaultFormatter = val => {
  return val + '%'
}

const MixedChartWrapper = ({
  data,
  labels,
  width,
  formatter = defaultFormatter,
  legendProps,
  yProps,
  colors,
}) => {
  const options = {
    chart: {
      type: 'line',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    stroke: {
      width: [0, 4],
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1],
      formatter,
      style: {
        fontSize: '14px',
      },
    },
    labels,
    yaxis: {
      labels: {
        style: {
          fontSize: '16px',
          fontWeight: 600,
        },
        formatter,
      },
      ...yProps,
    },
    xaxis: {
      labels: {
        rotate: -45,
        rotateAlways: true,
      },
    },
    legend: {
      onItemClick: {
        toggleDataSeries: false,
      },
      ...legendProps,
    },
    colors,
  }

  return (
    <Chart
      options={options}
      series={data}
      type='line'
      height='90%'
      width={width}
    />
  )
}

export default MixedChartWrapper
